import type { MenuItem } from '@backmarket/http-api/src/api-specs-navigation-experience/navigation/sidebar'

import type { NavigationItem } from '../types'

export const SEASONAL_HIGHLIGHT_COLOR = '#9D3963'

enum ItemType {
  CATEGORY = 'category',
  EVENT = 'event',
  GIFT = 'gift',
  UNIVERSE = 'universe',
}

export function toUrl(
  locale: string,
  name: string,
  id: string,
  type: string,
): string {
  if (type.toLowerCase() === ItemType.EVENT) {
    return `/${locale}/e/${name}`
  }
  if (
    type.toLowerCase() === ItemType.UNIVERSE ||
    type.toLowerCase() === ItemType.CATEGORY
  ) {
    return `/${locale}/l/${name}/${id}`
  }

  if (type.toLowerCase() === ItemType.GIFT && name === 'home') {
    return `/${locale}/${type}`
  }

  return `/${locale}/${type}/${name}`
}

export function mapMenuItem(item: MenuItem, locale: string): NavigationItem {
  return {
    children: item.children?.map((child) => mapMenuItem(child, locale)) || [],
    id: item.id,
    image: item.imageUrl,
    title: item.title,
    url: toUrl(locale, item.name, item.id, item.type),
    details: item.meta?.map((meta) => meta.sidebar),
    icon: item.icon,
    color: item.id === 'good-deals' ? SEASONAL_HIGHLIGHT_COLOR : undefined,
  }
}
